import { useCallback, useEffect, useState } from 'react';
import { isSSR } from 'src/helpers/ssr';
import { getFlagSigmaOptionByName } from '..';
import type { Experiments } from '../types';

const partnerArr = [1173, 973, 1190];

/**
 * После проведения A/B теста убрать код
 * https://tracker.yandex.ru/LT-41575
 */
/**
 * Хук для получения значения для эксперимента с новыми отзывами
 * @params isMobile
 * @returns key, value, variant
 */
export const useNewReviewsExperiment = (isMobile: boolean) => {
  // ID партнеров Тиньков, исключаем из A/B теста
  const [value, setValue] = useState<Experiments['ab_hotel_reviews'] | ''>('');
  const [isLoading, setIsLoading] = useState(true);
  const [variant, setVariant] = useState<'new' | 'old'>('old');

  const fetchSigmaFlag = useCallback(async () => {
    if (isSSR) return;
    const partnerId = window.PARTNER ? window.PARTNER.id : 0;
    /**
     * Для мобильной версии на основном сайте показываем новую версию
     * для партнеров показываем страую версию
     * сплитование не запускаем
     * */
    if (isMobile) {
      if (partnerId) {
        setVariant('old');
      } else {
        setVariant('new');
      }
    } else if (!partnerArr.includes(partnerId)) {
      const flagValue = await getFlagSigmaOptionByName('ab_hotel_reviews');
      setValue(flagValue ?? '');
      if (flagValue === 'new_1' || flagValue === 'new_2') {
        setVariant('new');
      } else {
        setVariant('old');
      }
    }
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchSigmaFlag();
  }, [fetchSigmaFlag]);

  return { key: 'ab_hotel_reviews', value, variant, isLoading };
};
